import { render, staticRenderFns } from "./HeaderCollapsePhone.vue?vue&type=template&id=ecd55a86&"
import script from "./HeaderCollapsePhone.vue?vue&type=script&lang=js&"
export * from "./HeaderCollapsePhone.vue?vue&type=script&lang=js&"
import style0 from "./HeaderCollapsePhone.vue?vue&type=style&index=0&id=ecd55a86&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports